<template>
    <div id="bttomLeftTop">
        <div class="bg-color-black">
            <myTitle :icon="'chart-line'">累积用电</myTitle>
            <div class="d-flex jc-center ai-end body-box pl-1 pr-1">
                <div v-for="(item, index) in list" :key="index">

                    <div class="card" v-if="!isNaN(item)" >{{item}}</div>
                    <div  v-else >{{item}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import myTitle from '@/components/common/title'
export default {
    data() {
        return {
            timing: null,
            num: 20621
        }
    },
    components: {
        myTitle
    },
    computed: {
        numStr: function () {
            return this.num.toString().padStart(8, '0')
        },
        list: function () {
            const reg = /(\d)(?=(?:\d{3})+$)/g;
            const arr = this.numStr.toString().replace(reg,'$1,')
            return arr.toString()
            // return this.numStr.toString()
        }
    },
    beforeDestroy() {
        clearInterval(this.timing)
    },
    mounted() {
        this.timing = setInterval(() => {
            this.num ++
        }, 1000)
    }
}
</script>
  
<style lang="scss" scoped>
$box-height: 150px;
$box-width: 100%;

#bttomLeftTop {
    padding: 16px;
    padding-top: 20px;
    height: $box-height;
    width: $box-width;
    border-radius: 5px;

    .bg-color-black {
        height: $box-height - 30px;
        border-radius: 10px;
    }

    .text {
        color: #c3cbde;
    }

    .body-box {
        border-radius: 10px;
        overflow: hidden;

        .card {
            background-color: rgba(4, 49, 128, .6);
            color: #08e5ff;
            width: 70px;
            font-size: 42px;
            font-weight: 700;
            line-height: 70px;
            text-align: center;
            margin: 3px;
        }
    }
}
</style>
  